export default __webpack_public_path__ + "static/media/m8werk_group.fdb9cfbc.png";